import React from 'react';
import { Box } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import Alert from '../Alert';
import { every } from 'lodash';

function PrivateFieldsWrapper({ children, alertText }: any) {
  if (!children) {
    return null;
  }

  if (every(children, (child: any) => !child)) {
    return null;
  }

  return (
    <Box
      sx={(theme: any) => ({
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: theme.shape.borderRadius / 2,
        mb: 3,
        padding: theme.spacing(3),
      })}
    >
      {alertText && (
        <Box sx={{ mb: 3 }}>
          <Alert severity="info" icon={<LockOutlinedIcon />}>
            {alertText}
          </Alert>
        </Box>
      )}

      {children}
    </Box>
  );
}

export default PrivateFieldsWrapper;
